import { api } from "./axiosInstance";

export interface ManagedUser {
  id: string;
  email: string;
  fullName: string | null;
  role: string;
  isActive: boolean;
  invitedAt: string | null;
  invitedBy: string | null;
  isPending: boolean;
  emailSent?: boolean | null;
  emailConfigured?: boolean;
}

export interface InviteUserRequest {
  email: string;
  role: string;
}

export interface ChangeRoleRequest {
  role: string;
}

const BASE = "/api/v1/admin/users";

export const getAllUsers = async (): Promise<ManagedUser[]> => {
  const { data } = await api.get<ManagedUser[]>(BASE);
  return data;
};

export const inviteUser = async (req: InviteUserRequest): Promise<ManagedUser> => {
  const { data } = await api.post<ManagedUser>(`${BASE}/invite`, req);
  return data;
};

export const changeUserRole = async (userId: string, req: ChangeRoleRequest): Promise<void> => {
  await api.patch(`${BASE}/${userId}/role`, req);
};

export const deactivateUser = async (userId: string): Promise<void> => {
  await api.patch(`${BASE}/${userId}/deactivate`);
};

export const reactivateUser = async (userId: string): Promise<void> => {
  await api.patch(`${BASE}/${userId}/reactivate`);
};

export const deleteUser = async (userId: string): Promise<void> => {
  await api.delete(`${BASE}/${userId}`);
};
